export default "__VITE_ASSET__9a2e5ffb__"